function setupWizard(el = 'body') {
  let currentStep = 0;
  const $el = $(el);

  if ($el.data('wizard-has-been-setted')) {
    return;
  }

  const formSteps = $el.find('.Form-step');

  // Jump out if there are no formSteps in this page
  if (formSteps.length === 0) { return; }

  // Display the next button on the form and hide the submit button
  $el.find('.Form-next').css('display', 'inline-flex');
  $el.find('.Form-final').hide();
  $el.find('input[type=submit]').hide();

  // Change the buttons available depending on step
  const updateInterface = function (step) {
    // First make sure the form actions are visible.
    // This allows you to manually hide them initially if necessary.
    $el.find('.Form-actions').show();

    switch (step) {
      case 0:
        $el.find('.Form-next').show();
        $el.find('.Form-previous').hide();
        $el.find('.Form-final').hide();
        $el.find('input[type=submit]').hide();
        break;
      case formSteps.length - 1:
        $el.find('.Form-next').hide();
        $el.find('.Form-previous').show();
        $el.find('.Form-final').show();
        $el.find('input[type=submit]').show();
        break;
      default:
        $el.find('.Form-next').show();
        $el.find('.Form-previous').show();
        $el.find('.Form-final').hide();
        $el.find('input[type=submit]').hide();
        break;
    }
  };

  // Iterate through the steps, hiding and displaying buttons as necessary
  const stepThrough = function (i) {
    // Determine if form isn't at the top of the page
    const formContainer = $('[data-form-step-selector]').data('form-step-selector');
    let yAxis;

    if (formContainer) {
      yAxis = $(formContainer).offset().top - 10;
    } else {
      yAxis = 0;
    }

    currentStep += i;
    updateInterface(currentStep);
    formSteps.eq(currentStep - i).hide();
    formSteps.eq(currentStep).show();
    window.scrollTo(0, yAxis);
  };

  // If there are errors on the page, we want to set the currentStep
  // variable to the same step that the first error is, instead of
  // forcing the user to go through from the start
  if ($el.find('.error').length > 0) {
    currentStep = $el.find('.error').eq(0).closest('.Form-step').index(`${el} .Form-step`);
    // Since we can't possibly be on the first step if there are errors,
    // Make sure to show the previous button
    updateInterface(currentStep);
  }

  // Hide the various steps of the form, except for the step we are on
  // TODO
  // Figure out a way to persist a half completed form (right now, we)
  // are just hiding portions of the form, so leaving the page would
  // erase any progress that we've made
  formSteps.hide();
  formSteps.eq(currentStep).show();

  // Add event listeners to the next and previous buttons
  $el.find('.Form-next').on('click', (e) => {
    e.preventDefault();
    const $button = $(e.target);

    if ($button.attr('disabled') !== false && !$button.hasClass('is-disabled')) {
      stepThrough(1);
    }
  });

  $el.find('.Form-previous').on('click', (e) => {
    e.preventDefault();
    stepThrough(-1);
  });

  // Allow the stepThrough function to be called outside the form
  $('.Form').on('form-step:next', () => {
    stepThrough(1);
  });

  $el.data('wizard-has-been-setted', true);
}

const initializeWizards = function () {
  // Only run this at the size of an iPhone 6+
  if (window.matchMedia('(max-width: 567px)').matches) {
    setupWizard('.Container');
  }
};

$(initializeWizards);

export default setupWizard;
